import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function Header() {
	const navigate = useNavigate();

	// Logout handler
	const handleLogout = async () => {
		await supabase.auth.signOut();
		navigate("/login");
	};

	return (
		<div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
			<h1 className="text-xl font-bold text-gray-900">BeskarOne</h1>
			<div className="flex gap-2">
				{/* Settings button */}
				<button className="w-8 flex items-center justify-center rounded-full hover:bg-gray-100" title="Settings" onClick={() => navigate("/homepage/settings")}>
					<span className="text-gray-400 text-2xl">&#9881;</span>
				</button>
				{/* Logout button */}
				<button className="flex items-center justify-center bg-gray-50 hover:bg-gray-200 rounded-lg border border-gray-200 shadow-s" title="Log out" onClick={handleLogout}>
					<span className="text-black font-medium px-3">Log off</span>
				</button>
			</div>
		</div>
	);
}
